import styles from './Footer.module.scss';
import PropTypes from 'prop-types';
const Footer = (props) => {
    const { lastRefreshDate } = props;
    return (
        <div className={styles.wrapper}>
            <div className={styles.leftSection}>
                COPYRIGHT © 2023 BY SYNPULSE. ALL RIGHTS RESERVED.
            </div>
            <div className={styles.rightSection}>
                Last Refresh Timestamp: {lastRefreshDate}
            </div>
        </div>
    );
};

Footer.propTypes = {
    lastRefreshDate: PropTypes.string
};

export default Footer;
